/* eslint-disable */
import i18n from "i18next";
import Cookies from "js-cookie";
import { initReactI18next } from "react-i18next";
import {
  getFormsEnData,
  getFormsFrData,
  getFormsEsData,
  getFormsItData,
  getTranslationEnData,
  getTranslationFrData,
  getTranslationEsData,
  getTranslationItData,
  getDistributorEnData,
  getDistributorFrData,
  getDistributorEsData,
  getDistributorItData,
  getCustomEnglishTranslation,
  getCustomFrenchTranslation,
  getCustomSpanishTranslation,
  getCustomItalianTranslation,
} from "./entities/translation/translation.service";
import { baseUriTranslate } from "./uri";

if (typeof baseUriTranslate != "undefined") {
  Promise.all([
    getTranslationEnData(),
    getFormsEnData(),
    getDistributorEnData(),

    getTranslationFrData(),
    getFormsFrData(),
    getDistributorFrData(),

    getTranslationEsData(),
    getFormsEsData(),
    getDistributorEsData(),

    getTranslationItData(),
    getFormsItData(),
    getDistributorItData(),

    getCustomEnglishTranslation(), // 12
    getCustomFrenchTranslation(), // 13
    getCustomSpanishTranslation(), // 14
    getCustomItalianTranslation(), // 15
  ])
    .then((values) => {
      const resources = {
        en: {
          translation: values[0].data,
          forms: values[1].data,
          distributor: values[2].data,
          custom: values[12].data,
        },
        fr: {
          translation: values[3].data,
          forms: values[4].data,
          distributor: values[5].data,
          custom: values[13].data,
        },
        es: {
          translation: values[6].data,
          forms: values[7].data,
          distributor: values[8].data,
          custom: values[14].data,
        },
        it: {
          translation: values[9].data,
          forms: values[10].data,
          distributor: values[11].data,
          custom: values[15].data,
        },
      };
      i18n
        .use(initReactI18next) // passes i18n down to react-i18next
        .init({
          resources,
          fallbackLng: ["en-US", "fr-FR"],
          lng: Cookies.get("lng") || "fr",
          ns: ["translation", "forms", "distributor", "custom"],
          defaultNS: "translation",
          fallbackNS: ["forms", "custom"],
          nsSeparator: ":",

          interpolation: {
            escapeValue: false, // react already safes from xss
          },
        });
    })
    .catch((error) => console.log(error));
}

export default i18n;
